import { apiCall } from "./Interceptor";

const SIGN_UP = "/onboarding/signup";
const UPDATE_PASSWORD = "/onboarding/update/password";
const CHECK_USERNAME_EXISTS = "/onboarding/validate-username/public";
const FORGOT_PASSWORD_REQUEST = '/onboarding/forgot-password-request/public';
const FORGOT_PASSWORD_RESET = '/onboarding/forgot-password-reset/public';
const VERIFY_EMAIL = '/onboarding/email-verification-link/public';
const OTP_TO_VERIFY_EMAIL = '/onboarding/validate-email/public';

const signUpForm = async (data) => {
    const response = await apiCall.post(SIGN_UP,data);
    return response;
}
const updatePassword = async (data) => {
    const response = await apiCall.put(UPDATE_PASSWORD,data);
    return response;
}

const getUsernameExists = async (uName) => {
    const response = await apiCall.get(`${CHECK_USERNAME_EXISTS}?userName=${uName}`);
    return response;
}
const forgotPasswordRequest = async (data) => {
    const response = await apiCall.patch(FORGOT_PASSWORD_REQUEST,data);
    return response;
}
const forgotPasswordReset = async (data) => {
    const response = await apiCall.patch(FORGOT_PASSWORD_RESET,data);
    return response;
}
const verifyEmailAddress = async (email) => {
    const response = await apiCall.get(`${VERIFY_EMAIL}?email=${email}`);
    return response;
}
const otpVerifyEmailAddress = async (otp,email) => {
    const response = await apiCall.get(`${OTP_TO_VERIFY_EMAIL}?otp=${otp}&email=${email}`);
    return response;
}
export default {
    signUpForm,
    updatePassword,
    getUsernameExists,
    forgotPasswordRequest,
    forgotPasswordReset,
    otpVerifyEmailAddress,
    verifyEmailAddress,
};
